export default (value) => {
  return value.length >= 8;
};
